import { Injectable } from '@angular/core';
import { API_URLS } from '../../../../../../environments/env-routes';
import { User } from '../../../../../../shared/models/user.class';
import { APIHelper } from '../../../../../../shared/services/api-helper/api-helper.service';
import { PaginationParams } from 'src/app/+home/+my-libraries/+sites/document-library/shared/services/nodes.service';
@Injectable({
  providedIn: 'root'
})
export class PeopleService {
  constructor(private api: APIHelper) { }

  public getAllPeople(): Promise<User[]> {
    return this.api.requestApi({ action: API_URLS.people.getAll }).then(res => {
      return res.list.entries.map(obj => {
        return new User(obj.entry);
      });
    });
  }
  public getAllPeoplepagination(pagination: PaginationParams = {
    maxItems: 10,
    skipCount: 0
  }): Promise<any> {

    let args =
      `maxItems=${pagination.maxItems}&` +
      `skipCount=${pagination.skipCount}`;
    ;
    return this.api.requestApi({ action: API_URLS.people.getAll, queryArgs: args }).then(res => {

      return res;
      // return res.list.entries.map(obj => {
      //   return new User(obj.entry);
      // });
    });
  }


  public getOnePeople(id: string): Promise<User> {
    return this.api
      .requestApi({ action: API_URLS.people.get.replace(':userId', id + '') })
      .then(res => {
        return new User(res);
      });
  }

  public createUser(data: any): Promise<any> {
    return this.api
      .requestApi({
        action: API_URLS.people.create,
        method: 'POST',
        datas: data
      })
      .then(res => {
        return res;
      });
  }

  public editUser(data: any, username: string): Promise<any> {
    const pdata: any = {
      oldpw: data.oldpwd,
      newpw: data.password
    };

    

    return this.api
      .requestApi({
        action: API_URLS.people.edit.replace(':username', username),
        method: 'PUT',
        datas: data
      })
      .then((res) => {
        this.api.requestApi({
          action: API_URLS.people.updatePassword.replace(':username', username),
          method: 'POST',
          datas: pdata
        });
        return res;
      });
  }

  public deleteUser(username: string) {
    return this.api
      .requestApi({
        action: API_URLS.people.delete.replace(':username', username + ''),
        method: 'DELETE'
      })
      .then(res => {
        return true;
      });
  }
  public queryPeople(term, pagination) {
    const args = `term=${term}&skipCount=${pagination.skipCount}&maxItems=${pagination.maxItems}`;
    return this.api.requestApi({ action: API_URLS.people.query, queryArgs: args });
  }
}
